import { ClearAllDataSaga, ClearSingleImporterDataSaga } from './ClearImporterDataSaga'

export default [ClearAllDataSaga, ClearSingleImporterDataSaga]
